
import React, { useEffect, useState } from "react";
import moment from "moment";
import Grid from "@mui/material/Grid";
import axios from "axios";
import Links from "../../../src/Data/Links.js";
import DashboardAccounting from "../../component/Reports/DashboardAccounting.js";
import SummaryReportsTableAllDivisions from "../../component/Reports/SummaryReportsTableAllDivisions.js";
import CarLoading from "../../images/487.gif";
import BarChart from "../../component/Charts/BarChart.js"
import getFiscals from '../../utils/getFiscals';

export default function DashboardAccountingModal({division,Modalmonth,Modalyear,week,columnName}) {
 
  const divisions = ['Auto', 'Rec', 'Used', 'FFUN Financial'];
  const currentYear = moment().format("YYYY");
  const currentMonth = moment().format("MMM");
  const [month, setMonth] = useState(Modalmonth);
  const [year, setYear] = useState(Modalyear);
  const [category, setCategory] = useState("New Vehicles");
  const [loading, setLoading] = useState(true);
  const [showNumbers, setShowNumbers] = useState(true);





  return (
    <div className="mx-auto" style={{ marginTop: "3rem", width: "100%" }}>
            <Grid container spacing={2}>
           

                <Grid item container xs={12}>
                    <Grid className="mx-auto overflow-auto" >
           
          
              <>
               

{
                                division=="auto" &&    <DashboardAccounting
                                division='Auto'
                                Modalmonth={Modalmonth}
                                Modalyear={Modalyear}
                                week={week}
                                columnName={columnName}
                       
                              />
                                
                            }

                            {
                                division=="rec" && 
                                <DashboardAccounting
                                division='Rec'
                                Modalmonth={Modalmonth}
                                Modalyear={Modalyear}
                                week={week}
                                columnName={columnName}
                              />
                           }

                            {
                                division=="used" && 
                                <DashboardAccounting
                                division='Used'
                                Modalmonth={Modalmonth}
                                Modalyear={Modalyear}
                                week={week}
                                columnName={columnName}
                              />
                           }
              </>
            
          </Grid>
        </Grid>
 
      </Grid>
    </div>
  );
}
